import { PropsWithChildren, createContext, useContext, useState } from "react";

import AsyncStorage from "@react-native-async-storage/async-storage";

type ContextType = {
  selectedDevScreen: string | undefined;
  toggleDevScreen: (screen: string) => Promise<void>;
};

const Context = createContext<ContextType | null>(null);

export default function useDev() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("useDev must be used within a DevProvider");
  return ctx;
}

const SELECTED_DEV_SCREEN_KEY = "appDevScreen";
let initialDevScreen: string | undefined;

(async () => {
  const savedDevScreen = await AsyncStorage.getItem(SELECTED_DEV_SCREEN_KEY);
  if (savedDevScreen) {
    initialDevScreen = savedDevScreen as string;
  }
})();

export function DevProvider({ children }: PropsWithChildren) {
  const [selectedDevScreen, setSelectedDevScreen] = useState(initialDevScreen);

  async function toggleDevScreen(screen: string) {
    if (selectedDevScreen === screen) {
      await AsyncStorage.removeItem(SELECTED_DEV_SCREEN_KEY);
      setSelectedDevScreen(undefined);
    } else {
      await AsyncStorage.setItem(SELECTED_DEV_SCREEN_KEY, screen);
      setSelectedDevScreen(screen);
    }
  }

  return (
    <Context.Provider value={{ selectedDevScreen, toggleDevScreen }}>
      {children}
    </Context.Provider>
  );
}
